import crypto from 'crypto';

/** 암호화 모듈 */
let rsa = {};

// crypto 는 nodejs 내장 모듈이라 브라우저에서 사용 불가. 대체 라이브러리 필요
// 지금은 node-polyfill-webpack-plugin 에서 polyfill 해줘서 돌아감
// 브라우저 네이티브 Web Crypto API로 대체 필요
const RSA_PUBLIC_KEY = '-----BEGIN PUBLIC KEY-----\nMIICIjANBgkqhkiG9w0BAQEFAAOCAg8AMIICCgKCAgEAiXqxFRL2JiQYxi4KsFMF\nD9A/3txEf+I61TkfIqfHJxO2+KP7UAi+PbIHQhbfHpS7LwFHRKv/INrgMjm2jNVd\neNgKrWpWsWGUx8mZH46ER4PyNfTe5SDPdC2TNae8TSFjd/DY9Yo5dzkgpu0zDOfT\nr7akoQ5YPTtB3DLWUtPc7Tugsv1am+w7sveIygh3gxB8ujj095QmwVyNEojt8AXn\n/gpZp3SQRuvliTcTxYbo0DX3At5ExBMRPE7nT4h+kcbmK0M5+6D6jFOTNZJdGsI+\nzyhzt1sssnRTP2vhCk5FeueXVjubfv1L8vJlTcIVnLQhfSUecWHWBJs+LcoFCBne\nN59YTqjgpkzdIXPvdhJ7gBZoLdvvj1m3LcxaQcLYvtcGXOUJtH0WKJyVkAvZ4xj3\nrnU9G8wql/TzBEhscGr+ldxBZKTX5MUQkzpEHlrKFIaRs+4iGr1V6dd3NdckfAkH\nHGjeID+OoWkE5T+z5YZK87UdTBpuWMos9stkYucUtmJBX/rrBydVKvZnr9txesnT\nHxuz/8P5NTBAE8FFrXZbpss5JKBP53Xk6yNVGwrxng7gkwmayFDfqX4GGSj+yEb6\nc9om0di34s3LEr8zG9+q2Tbs3m/FSd5+V+0l827RLihQT+n432WShbO1gV5MD1Ro\nVzHcUu6NSTrUhbGEfm7LRysCAwEAAQ==\n-----END PUBLIC KEY-----'

export function encrypt(val) {  
  const buffer = Buffer.from(val);
  const encrypted = crypto.publicEncrypt(RSA_PUBLIC_KEY, buffer);
  return encrypted.toString("hex");
}
rsa.encrypt = encrypt;

export default rsa;